import React from 'react';
import celebrateImage from './images/celebrate.png';
import attachImage from './images/attach.png';
import detailsImage from './images/details.png';
import createImage from './images/create.png';
import filesImage from './images/files.png';
import sendImage from './images/send.png';

export const steps = [
  {
    image: celebrateImage,
    title: 'Great Job!',
    description: (
      <>
        You have introduced yourself to your first lead!
        <br />
        Here you can chat with a lead, send files, and request info.
      </>
    ),
    onBackLabel: 'Close',
    onNextLabel: 'See Features',
  },
  {
    refId: 'attach-files',
    image: attachImage,
    title: 'Attach files',
    description: (
      <>
        Attach files to send your lead via this button. Files will appear
        <br />
        in the chat box. Send with the &apos;Send message&apos; button.
      </>
    ),
    onBackLabel: 'Back',
    onNextLabel: 'Next',
  },
  // {
  //   refId: 'request-details',
  //   image: detailsImage,
  //   title: 'Request info',
  //   description: (
  //     <>
  //       Request the private details of your lead including case information.
  //       <br />A message is automatically sent to the user.
  //     </>
  //   ),
  //   onBackLabel: 'Back',
  //   onNextLabel: 'Next',
  // },
  {
    refId: 'create-matter',
    image: createImage,
    title: 'Create matter',
    description: (
      <>
        Create a matter using the user details
        <br />
        of the case presented to you.
      </>
    ),
    onBackLabel: 'Back',
    onNextLabel: 'Next',
  },
  {
    refId: 'case-files',
    image: filesImage,
    title: 'Files',
    description: (
      <>You can view and download files from the user&apos;s case here.</>
    ),
    onBackLabel: 'Back',
    onNextLabel: 'Next',
  },
  {
    refId: 'send-messages',
    image: sendImage,
    title: 'Send messages',
    description: (
      <>
        When you are ready, send messages using the &apos;Send message&apos;
        button.
      </>
    ),
    onBackLabel: 'Back',
    onNextLabel: 'Finish tour',
  },
];
